import React, { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import alert from '../../helpers/alert';
import addVinToBlacklist from '../../api/vinBlacklist/addVinToBlacklist';
import importVinBlacklist from '../../api/vinBlacklist/importVinBlacklist';
import {
  ALLOWED_EXTENSIONS,
  SAMPLE_CSV_HREF,
  VIN_LENGTH,
  fileProblem,
  importSummary,
  normalizeVinInput,
} from './vinBlacklistHelpers';
import styles from './addVinModal.module.css';

// ÐÐ¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð² ÑÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº: Ð¾Ð´Ð¸Ð½ VIN Ð²ÑÑÑÐ½ÑÑ Ð¸Ð»Ð¸ ÑÐ°Ð¹Ð». Ð¤Ð°Ð¹Ð» Ð²ÑÐµÐ³Ð´Ð° ÐÐÐÐÐÐÐ¯ÐÐ¢ ÑÐ¿Ð¸ÑÐ¾Ðº, Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð·Ð°Ð¼ÐµÐ½ÑÐµÑ.
// ÐÑÐ¸Ð±ÐºÐ¸ Ð±ÑÐºÐ° (VIN ÑÐ¶Ðµ Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð¸ Ñ.Ð¿.) Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ Ð¾Ð±ÑÐ¸Ð¹ api.onError.
const AddVinModal = ({ isOpen, onClose, onDone }) => {
  const [mode, setMode] = useState('manual');
  const [vin, setVin] = useState('');
  const [reason, setReason] = useState('');
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [saving, setSaving] = useState(false);

  const canSubmit = mode === 'manual' ? vin.length === VIN_LENGTH : !!file;

  const pickFile = (picked) => {
    if (!picked) return;
    const problem = fileProblem(picked);
    if (problem) {
      alert.error(problem);
      return;
    }
    setFile(picked);
  };

  const finish = () => {
    setVin('');
    setReason('');
    setFile(null);
    onDone();
  };

  const submit = () => {
    setSaving(true);
    const request = mode === 'manual' ? addVinToBlacklist({ vin, reason: reason.trim() }) : importVinBlacklist([file]);
    request
      .then((res) => {
        alert.success(mode === 'manual' ? 'VIN Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½' : importSummary(res?.data));
        finish();
      })
      .catch(() => {})
      .finally(() => setSaving(false));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð² ÑÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº"
      overlayStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      contentStyle={{
        position: 'relative',
        inset: 'auto',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '90%',
        maxWidth: 520,
        maxHeight: '90vh',
        overflow: 'auto',
      }}
    >
      <div className={styles.modes}>
        <button
          type="button"
          className={`${styles.mode} ${mode === 'manual' ? styles.modeActive : ''}`}
          onClick={() => setMode('manual')}
        >
          ÐÑÑÑÐ½ÑÑ
        </button>
        <button
          type="button"
          className={`${styles.mode} ${mode === 'import' ? styles.modeActive : ''}`}
          onClick={() => setMode('import')}
        >
          ÐÐ¼Ð¿Ð¾ÑÑ Ð¸Ð· ÑÐ°Ð¹Ð»Ð°
        </button>
      </div>

      <div className={styles.body}>
        <div className={`${styles.pane} ${mode === 'manual' ? '' : styles.paneHidden}`}>
          <div className={styles.fields}>
            <Input
              title="VIN"
              placeholder="Ð£ÐºÐ°Ð¶Ð¸ÑÐµ VIN"
              maxLength={VIN_LENGTH}
              value={vin}
              handleSetState={(value) => setVin(normalizeVinInput(value))}
            />
            <Input title="ÐÑÐ¸ÑÐ¸Ð½Ð°" placeholder="ÐÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾" value={reason} handleSetState={setReason} />
          </div>
        </div>

        <div className={`${styles.pane} ${mode === 'import' ? '' : styles.paneHidden}`}>
          <label
            className={`${styles.drop} ${dragOver ? styles.dropActive : ''}`}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(true);
            }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              e.preventDefault();
              setDragOver(false);
              pickFile(e.dataTransfer.files?.[0]);
            }}
          >
            <span className={styles.dropTitle}>{file ? file.name : 'ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ°Ð¹Ð» Ð¸Ð»Ð¸ Ð¿ÐµÑÐµÑÐ°ÑÐ¸ÑÐµ ÑÑÐ´Ð°'}</span>
            <span className={styles.dropHint}>{ALLOWED_EXTENSIONS.join(', ')}</span>
            <input
              type="file"
              accept={ALLOWED_EXTENSIONS.join(',')}
              hidden
              onChange={(e) => pickFile(e.target.files?.[0])}
              onClick={(e) => (e.target.value = null)}
            />
          </label>
          <p className={styles.format}>
            ÐÐ¾Ð»Ð¾Ð½ÐºÐ¸: VIN Ð¸ ÐÑÐ¸ÑÐ¸Ð½Ð° (Ð½ÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾). VIN Ð¸Ð· ÑÐ°Ð¹Ð»Ð° Ð´Ð¾Ð±Ð°Ð²Ð»ÑÑÑÑÑ Ðº ÑÐ¿Ð¸ÑÐºÑ, ÑÐ¶Ðµ Ð¸Ð¼ÐµÑÑÐ¸ÐµÑÑ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÑÑÑÑ,
            Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÐ´Ð°Ð»ÑÐµÑÑÑ.{' '}
            <a href={SAMPLE_CSV_HREF} download="vin-blacklist-example.csv">
              Ð¡ÐºÐ°ÑÐ°ÑÑ Ð¿ÑÐ¸Ð¼ÐµÑ
            </a>
          </p>
        </div>
      </div>

      <Button text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ" fill full disabled={!canSubmit || saving} onClick={submit} />
    </Modal>
  );
};

export default AddVinModal;
